import { render } from "./Step3.vue?vue&type=template&id=1a5639c9"
import script from "./Step3.vue?vue&type=script&lang=js"
export * from "./Step3.vue?vue&type=script&lang=js"

import "./Step3.vue?vue&type=style&index=0&id=1a5639c9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__